<template>
  <router-view>
    <template v-slot="{ Component }">
      <component
        :is="Component"
        :resolving-state="resolvingState"
        :resolve-result="resolveResult"
      />
    </template>
  </router-view>
</template>

<script setup lang="ts">
import type { RouteLocationNormalized } from 'vue-router'
import { onMounted, onUnmounted } from '@/composition/vue/compositionApi'
import { type RESOLVER_BASE_PROPS, useResolvers } from '@/composition/resolvers'
import { ROUTER_AFTER_EACH } from '@/services/route/types'
import { useSubscription } from '@/composition/subscription'

const props = defineProps<RESOLVER_BASE_PROPS>()

const { resolve, unresolve, resolvingState, resolveResult } = useResolvers(props.routeName, props.resolvers)

useSubscription(ROUTER_AFTER_EACH, (to: RouteLocationNormalized) => {
  if (to.name === props.routeName) {
    resolve()
  }
})

onMounted(() => {
  resolve()
})

onUnmounted(() => {
  unresolve()
})
</script>
